// import node module libraries
import { Alert, Button, Col, Form, Row } from 'react-bootstrap';
import Select from 'react-select';

// import custom components
// import bootstrap icons
import { ExclamationTriangleFill } from 'react-bootstrap-icons';
import { useEffect, useState } from 'react';
import TenueService from '../../services/TenueService';

const OffcanvasAddTenueForm = ({ onClick }) => {
	const [eleveOptions, setEleveOptions] = useState([]);
	const [validated, setValidated] = useState(false);
	const [feedbackMessages, setFeedbackMessages] = useState({});
	const [showAlert, setShowAlert] = useState(false);
	const [alertMessage, setAlertMessage] = useState('');

	const TYPE_CHOICES = [
		{ value: 'tenue_classe', label: 'Tenue Classe' },
		{ value: 'tenue_sport', label: 'Tenue Sport' },
		{ value: 'pull', label: 'Pull' }
	];

	const TAILLE_CHOICES = [
		{ value: 's', label: 'S' },
		{ value: 'm', label: 'M' },
		{ value: 'l', label: 'L' },
		{ value: 'xl', label: 'XL' },
		{ value: 'xxl', label: 'XXL' },
		{ value: '3xl', label: '3XL' }
	];

	const handleSubmit = async (event) => {
		event.preventDefault();
		const form = event.currentTarget;

		if (form.checkValidity() === false) {
			event.stopPropagation();
		} else {
			try {
				const tenueData = new FormData();

				// Add all your form data to the FormData
				tenueData.append('fournisseur', form.fournisseur.value);
				tenueData.append('type', form.type.value);
				tenueData.append('prix', form.prix.value);
				tenueData.append('quantite', form.quantite.value);
				tenueData.append('taille', form.taille.value);

				// Call the TenueService to create the Tenue
				const response = await TenueService.createTenue(tenueData);

				// Reset the form and state variables after successful creation
				form.reset();
				setValidated(false);
				setFeedbackMessages({});

				// Redirect the user to the list of Tenues
				window.location.href = '/finances/tenues';
			} catch (error) {
				console.error('Erreur lors de la création de la tenue', error);

				if (error.response && error.response.data) {
					const apiErrors = error.response.data;

					// If there are field-specific errors
					if (typeof apiErrors === 'object' && !Array.isArray(apiErrors)) {
						const newFeedbackMessages = {};

						for (const field in apiErrors) {
							newFeedbackMessages[field] = apiErrors[field][0];
						}

						setFeedbackMessages(newFeedbackMessages);
					}

					// If there's a general error detail message
					if (apiErrors.detail) {
						setAlertMessage(apiErrors.detail[0]);
						setShowAlert(true);

						// Hide the alert after 5 seconds
						setTimeout(() => {
							setShowAlert(false);
						}, 10000);
					} else if (
						apiErrors['Il ya erreur'] &&
						apiErrors['Il ya erreur'][0]
					) {
						setAlertMessage(apiErrors['Il ya erreur'][0]);
						setShowAlert(true);

						// Hide the alert after 5 seconds
						setTimeout(() => {
							setShowAlert(false);
						}, 10000);
					}
				} else {
					alert(
						"Une erreur s'est produite lors de la soumission du formulaire."
					);
				}
			}
		}

		setValidated(true);
	};

	return (
		<Form
			className="mb-3"
			noValidate
			validated={validated}
			onSubmit={handleSubmit}
		>
			{showAlert && (
				<Alert variant="danger">
					<ExclamationTriangleFill size={25} className="me-1" />
					{alertMessage}
				</Alert>
			)}
			<Row>
				{/* type */}
				<Col xs={12} className="mb-3">
					<Form.Group className="mb-3">
						<Form.Label htmlFor="type">
							Type de tenue <span className="text-danger">*</span>
						</Form.Label>
						<Form.Select
							name="type"
							required
							isInvalid={!!feedbackMessages['type']}
							onChange={(e) => {
								setFeedbackMessages((prevMessages) => ({
									...prevMessages,
									type: e.target.value ? '' : 'Le type de Tenue est requis.'
								}));
							}}
						>
							{TYPE_CHOICES.map((option, index) => (
								<option key={index} value={option.value}>
									{option.label}
								</option>
							))}
						</Form.Select>
						<Form.Control.Feedback type="invalid">
							{feedbackMessages['type']}
						</Form.Control.Feedback>
					</Form.Group>
				</Col>

				{/* taile */}
				<Col xs={12} className="mb-3">
					<Form.Group className="mb-3">
						<Form.Label htmlFor="taille">
							Taille <span className="text-danger">*</span>
						</Form.Label>
						<Form.Select
							name="taille"
							required
							isInvalid={!!feedbackMessages['taille']}
							onChange={(e) => {
								setFeedbackMessages((prevMessages) => ({
									...prevMessages,
									taille: e.target.value
										? ''
										: 'La taille de la Tenue est requis.'
								}));
							}}
						>
							{TAILLE_CHOICES.map((option, index) => (
								<option key={index} value={option.value}>
									{option.label}
								</option>
							))}
						</Form.Select>
						<Form.Control.Feedback type="invalid">
							{feedbackMessages['taille']}
						</Form.Control.Feedback>
					</Form.Group>
				</Col>

				<Col xs={12} className="mb-3">
					{/* prix et quantite  */}
					<Form.Group>
						<Row>
							<Col md={6} sm={12} className="mb-3">
								<Form.Label htmlFor="prix">
									Prix <span className="text-danger">*</span>
								</Form.Label>
								<Form.Control
									name="prix"
									type="number"
									placeholder="Saisir le prix de la Tenue"
									id="prix"
									required
									isInvalid={!!feedbackMessages['prix']}
									onChange={(e) => {
										setFeedbackMessages((prevMessages) => ({
											...prevMessages,
											prix: e.target.value ? '' : 'Le prix est requis.'
										}));
									}}
								/>
								<Form.Control.Feedback type="invalid">
									{feedbackMessages['prix']}
								</Form.Control.Feedback>
							</Col>
							<Col md={6} sm={12} className="mb-3">
								<Form.Label htmlFor="quantite">Quantite</Form.Label>
								<Form.Control
									name="quantite"
									type="number"
									placeholder="Saisir la quantite de Tenue"
									id="quantite"
									required
									isInvalid={!!feedbackMessages['quantite']}
									onChange={(e) => {
										setFeedbackMessages((prevMessages) => ({
											...prevMessages,
											quantite: e.target.value ? '' : 'La quantite est requis.'
										}));
									}}
								/>
								<Form.Control.Feedback type="invalid">
									{feedbackMessages['quantite']}
								</Form.Control.Feedback>
							</Col>
						</Row>
					</Form.Group>
				</Col>

				<Col xs={12} className="mb-3">
					{/* fournisseur  */}
					<Form.Group>
						<Form.Label htmlFor="fournisseur">
							Fournisseur <span className="text-danger">*</span>
						</Form.Label>
						<Form.Control
							name="fournisseur"
							type="text"
							placeholder="Saisir le fournisseur de la Tenue"
							id="fournisseur"
							required
							isInvalid={!!feedbackMessages['fournisseur']}
							onChange={(e) => {
								setFeedbackMessages((prevMessages) => ({
									...prevMessages,
									fournisseur: e.target.value
										? ''
										: 'Le fournisseur est requis.'
								}));
							}}
						/>
						<Form.Control.Feedback type="invalid">
							{feedbackMessages['fournisseur']}
						</Form.Control.Feedback>
					</Form.Group>
				</Col>

				{/* Buttons */}
				<Col xs={12} className="mt-4">
					<Button variant="success" type="submit">
						Enregistrer
					</Button>
					<Button onClick={onClick} variant="outline-danger" className="ms-2">
						Fermer
					</Button>
				</Col>
			</Row>
		</Form>
	);
};

export default OffcanvasAddTenueForm;
